
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { StateSelect } from "./StateSelect";
import type { NewClientFormData } from "./types";
import type { State } from "./types";

interface AddressFieldsProps {
  formData: NewClientFormData;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStateChange: (value: string) => void;
  states: State[];
  isLoadingStates: boolean;
}

export const AddressFields = ({
  formData,
  onChange,
  onStateChange,
  states,
  isLoadingStates
}: AddressFieldsProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="street" className="text-sm font-medium text-primary-dark">Street Address</Label>
        <Input
          id="street"
          name="street"
          value={formData.street}
          onChange={onChange}
          className="h-12 bg-white border-[#E5DEFF] focus:ring-[#9b87f5] transition-shadow"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="city" className="text-sm font-medium text-primary-dark">City</Label>
          <Input
            id="city"
            name="city"
            value={formData.city}
            onChange={onChange}
            className="h-12 bg-white border-[#E5DEFF] focus:ring-[#9b87f5] transition-shadow"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="state" className="text-sm font-medium text-primary-dark">State</Label>
          <StateSelect
            states={states}
            value={formData.state}
            onChange={onStateChange}
            isLoading={isLoadingStates}
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="zipCode" className="text-sm font-medium text-primary-dark">ZIP Code</Label>
        <Input
          id="zipCode"
          name="zipCode"
          value={formData.zipCode}
          onChange={onChange}
          className="h-12 bg-white border-[#E5DEFF] focus:ring-[#9b87f5] transition-shadow"
        />
      </div>
    </>
  );
};
